import {
  Box,
  Container,
  Flex,
  Grid,
  Heading,
  Text,
} from '@joinrepublic/dls-ui-kit';

import { colors, containerSize, InterDisplayStyles } from '../../config/styles';
import { MotionBox } from '../motion-box/motion-box';
import { MotionBoxGroup } from '../motion-box-group/motion-box-group';
import { SlidingCounter } from '../sliding-counter/sliding-counter';
import { BACKED_BY_INVESTORS_LOGOS, REPUBLIC_STATS } from './data';

export const RepublicNumbers = () => {
  return (
    <Box
      as="section"
      id="republic-numbers"
      bg={colors.lightNavy}
      pt={{ base: '10', sm: '20' }}
      pb={{ base: '10', sm: '0' }}
    >
      <Container maxW={containerSize}>
        <MotionBox>
          <Grid
            templateColumns={{ base: '1fr', sm: 'repeat(2, 1fr)' }}
            rowGap={8}
          >
            <Box as="header" pr={{ base: '0', sm: '12' }}>
              <Heading
                as="h2"
                mt="0"
                maxW="520px"
                size="title-md"
                color={colors.darkNavyTypography}
              >
                Republic is a leader in real world assets, tokenization, and
                blockchain infrastructure
              </Heading>
            </Box>

            <Box pl={{ base: '0', md: '8', lg: '16' }}>
              <Text mb="4" size="body-sm" variant="text-secondary">
                Data as of 05/01/25
              </Text>
              <Grid
                templateColumns={{ base: 'repeat(2, 1fr)' }}
                rowGap={{ base: '14', md: '16' }}
              >
                {REPUBLIC_STATS.map((stat, index) => (
                  <Box
                    key={index}
                    borderTop="1px solid"
                    borderTopColor="blackAlpha.300"
                    pt={{ base: '4', md: '5' }}
                    pr="5"
                  >
                    <SlidingCounter
                      value={parseFloat(stat.amount)}
                      prefix={stat.prefix}
                      suffix={stat.suffix}
                      fontSize={{ base: '56px', md: '68px', lg: '80px' }}
                      fontWeight="400"
                      lineHeight="1em"
                      letterSpacing="-0.02em"
                      color={colors.darkNavyTypography}
                      sx={InterDisplayStyles}
                    />
                    <Text
                      size={{ base: 'body-xs' }}
                      textStyle={{ md: 'body-sm-md' }}
                      variant="text-secondary"
                      maxW={{ base: '140px', md: '245px' }}
                    >
                      {stat.caption}
                    </Text>
                  </Box>
                ))}
              </Grid>
            </Box>
          </Grid>
        </MotionBox>

        <MotionBoxGroup
          mt={{ base: '10', sm: '16' }}
          mx={{ base: '-4', sm: '0' }}
          pt={{ base: '8', md: '0' }}
          borderTop={{ base: '1px solid', sm: 'none' }}
          borderTopColor="blackAlpha.300"
        >
          <MotionBox>
            <Text
              as="h4"
              textStyle={{ base: 'body-sm-md' }}
              variant="text-secondary"
              mb={{ base: '6', md: '8' }}
              textAlign={{ base: 'center', md: 'left' }}
            >
              Backed by 25+ VC and PE firms
            </Text>

            <Box overflow="hidden">
              <Flex
                flexWrap={{ base: 'wrap', md: 'nowrap' }}
                justify="center"
                rowGap="12"
                ml="-1px"
                py="6"
              >
                {BACKED_BY_INVESTORS_LOGOS.map((Logo, index) => (
                  <Flex
                    key={index}
                    as="figure"
                    flexBasis={{ base: '50%', sm: '33.333%', md: 'auto' }}
                    flexGrow="1"
                    justify="center"
                    px={{ base: '2', sm: '4' }}
                    borderLeft="1px solid"
                    borderLeftColor="blackAlpha.300"
                    h={{ base: '45px', md: 'auto' }}
                  >
                    <MotionBox effect="scaleFadeIn" delay={index * 0.07 + 0.3}>
                      <Logo
                        style={{
                          maxWidth: '100%',
                          maxHeight: '100%',
                          objectFit: 'contain',
                        }}
                      />
                    </MotionBox>
                  </Flex>
                ))}
              </Flex>
            </Box>
          </MotionBox>
        </MotionBoxGroup>
      </Container>
    </Box>
  );
};
